import React from 'react';

const RectInverseIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16pt" height="16pt" viewBox="0 0 64 64" className="svg-icon lasso-inverse-icon" {...props}>
        <rect
            style={{stroke: 'none', fill: '#b3b3b3'}}
            width="66.983047"
            height="65.355934"
            x="-1.0847458"
            y="-0.40677971"/>
        <rect
            style={{stroke: '#000000', fill: '#ffffff', strokeWidth: 2}}
            width="50"
            height="40"
            x="5"
            y="10"/>
    </svg>
);

export default RectInverseIcon;



// WEBPACK FOOTER //
// ./src/components/RectInverseIcon.js